import { combineEpics, ofType } from "redux-observable"
import { from, concat, of, EMPTY } from "rxjs"
import { flatMap, catchError, filter, switchMap } from "rxjs/operators"
import { Epic } from "../../epics"

import * as actions from "./actions"
import { addErrorNotification } from "../notifications/actions"
import { RequestCancelledError } from "../../errors"

export const defaultRequestingShortcutsErrorMessage =
    "Something went wrong when fetching shortcuts."

export const initializeShortcutsEpics: Epic = (
    action$,
    state$,
    _dependencies$,
) =>
    action$.pipe(
        ofType(actions.INITIALIZE),
        filter(() => !state$.value.shortcuts.initialized),
        flatMap(() =>
            concat(
                of(actions.requestShortcuts()),
                of(actions.setInitialized()),
            ),
        ),
    )

export const requestShortcutsEpic: Epic = (
    action$,
    state$,
    { shortcuts: { shortcutAPI } },
) =>
    action$.pipe(
        ofType(actions.REQUEST_SHORTCUTS),
        switchMap(() => {
            const {
                shortcuts: { filter },
            } = state$.value
            return from(shortcutAPI.getShortcuts(null, filter)).pipe(
                flatMap(({ data }) => of(actions.receiveShortcuts(data))),
                catchError((error) => {
                    if (error instanceof RequestCancelledError) {
                        return EMPTY
                    }
                    console.error(error)
                    return concat(
                        of(actions.receiveShortcuts([])),
                        of(
                            addErrorNotification(
                                defaultRequestingShortcutsErrorMessage,
                            ),
                        ),
                    )
                }),
            )
        }),
    )

export default combineEpics(initializeShortcutsEpics, requestShortcutsEpic)
